import '@babel/polyfill/noConflict';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import moment from 'moment-timezone';
import VueMoment from 'vue-moment';
import VueRx from 'vue-rx';
import { store } from './store/store';
import Vuetify from 'vuetify';
import VuePaginate from 'vue-paginate';
import VueSanitize from 'vue-sanitize';
Vue.use(VueSanitize);

// Vue.config.devtools = true;
Vue.config.productionTip = false;
// Global mixins
Vue.mixin({
    methods: {
        isEmpty(container) {
            return typeof container === 'object' ? !Object.keys(container).length : !container.length;
        }
    }
})
// Analytic Categories constants, useful if they ever need to change
// TODO: is this overkill?
Vue.prototype.$analytics = {
    category: {
        personal: 'account',
        communications: 'communications',
        privacy: 'privacy',
        favorites: 'favorites',
        shipping: 'shipping',
        payments: 'payments',
        deposits: 'directDeposit',
        orders: 'orderHistory'
    }
};
Vue.use(VueRx);
Vue.use(Vuetify, { iconfont: 'md' });
Vue.use(VueMoment, { moment });
Vue.use(VuePaginate);
new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app');